export default "__VITE_PUBLIC_ASSET__bd008f1b__"